module.exports = require("element-ui/lib/utils/clickoutside");